const navToggles = document.querySelectorAll('.wp-block-hs-blocks-ui-nav-toggle') || [];
const uiRootContainer = document.querySelector('.wp-block-hs-blocks-ui-root-container') || false;


navToggles.forEach((e)=>{
    e.addEventListener('pointerup', ()=>{
        uiRootContainer.classList.toggle('ui-nav-active');
    })
})

